module.exports = __webpack_public_path__ + "img/Christmas-coupon-3.eedd6c2.png";